/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Notifications_All1Inputs */

const id_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua`)
};

const ms_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua`)
};

const da_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const de_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const en_us2_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const es_es2_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas`)
};

const es_mx2_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas`)
};

const fil_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat`)
};

const fr_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout`)
};

const it_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte`)
};

const hu_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mind`)
};

const nl_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const no_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const pl_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie`)
};

const pt_br2_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const pt_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas`)
};

const ro_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toate`)
};

const fi_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki`)
};

const sv_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla`)
};

const vi_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả`)
};

const tr_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tümü`)
};

const cs_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vše`)
};

const bg_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всички`)
};

const ru_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все`)
};

const uk_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі`)
};

const ar_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكل`)
};

const hi_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी`)
};

const th_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทั้งหมด`)
};

const ja_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて`)
};

const zh_cn2_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const zh_hant1_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const ko_offerdetail_notifications_all1 = /** @type {(inputs: Offerdetail_Notifications_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모두`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Offerdetail_Notifications_All1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_notifications_all1 = /** @type {((inputs?: Offerdetail_Notifications_All1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Notifications_All1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_notifications_all1(inputs)
	if (locale === "ms") return ms_offerdetail_notifications_all1(inputs)
	if (locale === "da") return da_offerdetail_notifications_all1(inputs)
	if (locale === "de") return de_offerdetail_notifications_all1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_notifications_all1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_notifications_all1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_notifications_all1(inputs)
	if (locale === "fil") return fil_offerdetail_notifications_all1(inputs)
	if (locale === "fr") return fr_offerdetail_notifications_all1(inputs)
	if (locale === "it") return it_offerdetail_notifications_all1(inputs)
	if (locale === "hu") return hu_offerdetail_notifications_all1(inputs)
	if (locale === "nl") return nl_offerdetail_notifications_all1(inputs)
	if (locale === "no") return no_offerdetail_notifications_all1(inputs)
	if (locale === "pl") return pl_offerdetail_notifications_all1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_notifications_all1(inputs)
	if (locale === "pt") return pt_offerdetail_notifications_all1(inputs)
	if (locale === "ro") return ro_offerdetail_notifications_all1(inputs)
	if (locale === "fi") return fi_offerdetail_notifications_all1(inputs)
	if (locale === "sv") return sv_offerdetail_notifications_all1(inputs)
	if (locale === "vi") return vi_offerdetail_notifications_all1(inputs)
	if (locale === "tr") return tr_offerdetail_notifications_all1(inputs)
	if (locale === "cs") return cs_offerdetail_notifications_all1(inputs)
	if (locale === "bg") return bg_offerdetail_notifications_all1(inputs)
	if (locale === "ru") return ru_offerdetail_notifications_all1(inputs)
	if (locale === "uk") return uk_offerdetail_notifications_all1(inputs)
	if (locale === "ar") return ar_offerdetail_notifications_all1(inputs)
	if (locale === "hi") return hi_offerdetail_notifications_all1(inputs)
	if (locale === "th") return th_offerdetail_notifications_all1(inputs)
	if (locale === "ja") return ja_offerdetail_notifications_all1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_notifications_all1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_notifications_all1(inputs)
	return ko_offerdetail_notifications_all1(inputs)
});
export { offerdetail_notifications_all1 as "offerDetail.notifications.all" }